var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 274,
    viewBox: "0 0 414 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_292)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5371 61.9717H310.641V227.308H89.5371V61.9717Z",
    fill: "#7D8FA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0781 58.5259H313.579V227.308H86.0781V58.5259Z",
    stroke: "white",
    strokeWidth: 6.54275,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_89_292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -74,
    width: 1036,
    height: 478
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 403.743H1036V-73.1641H0V403.743Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_89_292)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 227.308H395.933",
    stroke: "white",
    strokeWidth: 9.81412,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_89_292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -74,
    width: 1036,
    height: 478
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 403.743H1036V-73.1641H0V403.743Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_89_292)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M394.53 62.803L263.375 161.102",
    stroke: "#F8EC30",
    strokeWidth: 2.94302,
    strokeLinejoin: "round",
    strokeDasharray: "4.05 4.05"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.903 156.683L257.484 165.516L267.201 163.753L261.903 156.683Z",
    fill: "#F8EC30"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_89_292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -74,
    width: 1036,
    height: 478
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 403.743H1036V-73.1638H0V403.743Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_89_292)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.377 104.411H319.191V174.2H309.377V104.411Z",
    fill: "#17375E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_89_292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -74,
    width: 1036,
    height: 478
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 403.744H1036V-73.1636H0V403.744Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_89_292)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.844 170.981H286.997",
    stroke: "white",
    strokeWidth: 2.94302,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_89_292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -74,
    width: 1036,
    height: 478
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 403.744H1036V-73.1633H0V403.744Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_89_292)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.713 172.867H279.627V224.913H203.713V172.867Z",
    fill: "#F8F7F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_89_292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -74,
    width: 1036,
    height: 478
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 403.744H1036V-73.1631H0V403.744Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_89_292)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M320.506 94.5974L320.133 180.849",
    stroke: "#F8EC30",
    strokeWidth: 4.58074,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_89_292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -74,
    width: 1036,
    height: 478
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 403.744H1036V-73.1628H0V403.744Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_89_292)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2505 67.5554L86.0762 198.921",
    stroke: "#F8EC30",
    strokeWidth: 9.81412,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_89_292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -74,
    width: 1036,
    height: 478
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 403.745H1036V-73.1626H0V403.745Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_89_292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.364 163.807L96.377 121.774",
    stroke: "#F8EC30",
    strokeWidth: 2.94302,
    strokeLinejoin: "round",
    strokeDasharray: "4.46 4.46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5111 126.428L89.3359 119.642L99.0649 117.972L96.5111 126.428Z",
    fill: "#F8EC30"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 274,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.1aafa8aebb3b8088ddbba0840bb6adfb.svg";
export { ForwardRef as ReactComponent };